
function set(key, value) {
  window.sessionStorage.setItem(key, value);
}

function get(key) {
  return window.sessionStorage.getItem(key);
}


export class SessionStorage {

  getState() {
    return {
      orgId: get('orgId'),
      objId: get('objId'),
      trxId: get('trxId'),
      location: get('location'),
      category: get('category'),
      subcategory: get('subcategory'),
      startDate: get('startDate'),
      endDate: get('endDate'),
      duration: get('duration'),
      timeUnit: get('timeUnit'),      
    }
  }

  setState(state) {
    for(let k in state) {
      if(state[k]) {
        set(k, state[k]);
      }
    }
  }

  removeState(keys) {
    for(let k of keys) {
      window.sessionStorage.removeItem(k);
    }
  }
}


// WEBPACK FOOTER //
// ./src/model/SessionStorage.js